<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Add Member</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/persons" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="createPerson" v-if="person">
              <div class="row justify-content-md-center">
                <div class="col-12">
                  <div class="row">
                    <div class="col-md-5">
                      <fg-input type="text"
                                v-model="person.memberFirstName"
                                label="Name"
                                placeholder="Enter Member  Name"
                                v-validate="rules.memberFirstName"
                                data-vv-name="Name"
                                cus-name="Name"
                                :has-errors="errors"
                                :is-fields="fields">
                      </fg-input>
                    </div>
                    <div class="col-md-7">
                      <fg-input type="text"
                                v-model="person.memberImageUrl"
                                label="URL"
                                placeholder="Enter URL"
                                v-validate="rules.memberImageUrl"
                                data-vv-name="Image URL"
                                cus-name="Image URL"
                                :has-errors="errors"
                                :is-fields="fields"
                      >
                      </fg-input>
                    </div>
                    <div class="col-md-5">
                      <fg-input type="text"
                                v-model="person.position"
                                label="Designation"
                                placeholder="Enter Designation"
                                v-validate="rules.position"
                                data-vv-name="Designation"
                                cus-name="Designation"
                                :has-errors="errors"
                                :is-fields="fields"
                      >
                      </fg-input>
                    </div>
                    <div class="col-3" v-if="status.length">
                      <fg-select
                        v-model="person.active"
                        label="Status"
                        v-validate="rules.active"
                        data-vv-name="active"
                        cus-name="active"
                        :has-errors="errors"
                        :is-fields="fields"
                        :list="status"
                        selectedKey="id"
                      >
                      </fg-select>

                    </div>
                    <div class="col-md-12">
                      <fg-text-area type="text"
                                    v-model="person.biography"
                                    label="Biography"
                                    placeholder="Enter Member Biography"
                      >
                      </fg-text-area>
                    </div>
                  </div>
                </div>
                <div class="col-6 text-center">
                  <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                    Create Member
                  </button>
                </div>
              </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'CreatePerson',
        created (){
    },
    data () {
        return {
            person: {
                memberFirstName: '',
                memberImageUrl: '',
                position: '',
                biography: '',
                active: '1'
            },
            active: 1,
            status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
            rules: {
              memberFirstName: {required : true},
              memberImageUrl: {required : true},
              position: {required : true},
              active: {required: true}
            },
            message: {
                error: false,
                text: ''
            }
        }
    },
    methods: {
        createPerson () {
          console.log("this.Person : ", this.person);
          this.$validator.validateAll().then((result) => {
            if(result){
              this.$store.dispatch('ADD_PERSON', this.person)
                .then((res) => {
                  console.log("ADD_PERSON res : ", res);
                  if(res) this.showPopup('Success!', 'Member is successfully created', 'success', ()=>this.$router.push('/admin/persons'))
                  else this.showPopup('Error!', 'Unable to process.', 'error')
                })
                .catch(err => {
                  this.showPopup('Error!', 'some thing happen wrong', 'error')
                  console.log("ADD_PERSON API error : ", err);
                })
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    created() {

    },

    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Persons/CreatePerson.vue